import { Typography } from "@mui/material"
export default function RunPlaceholder() {
    return (
        <div className="w-full p-2 bg-gray-100 relative flex flex-row items-center">
            <div className="flex flex-row items-center justify-start sticky left-4">
                <Typography sx={{fontSize: "12px", color: "#000", pl: "1rem"}}>No runs available</Typography>
            </div>
        </div>
    )
}